import React from "react"
import { Image, Label, Popup } from "semantic-ui-react"
import DefaultServiceLogo from "../../../../images/default_wrench_icon.svg"
import LeftArrowIcon from "../../../../images/left_arrow_icon.svg"
import { ImageWithFallback } from "../../../../shared_component/elements/ImageWithFallback"
import InfoIcon from "../../../../images/info-Icon.svg"

const ServiceCategoryCard = ({
  categoryName,
  handleCategoryCardClick,
  serviceCount,
  description
}) => {
  const isFunctionEmpty = handleCategoryCardClick.toString().trim().length === 0
  const serviceLogoURL = `https://s3.amazonaws.com/assets.caradvise.com/service_categories/${categoryName
    .replace(/[\s\/]+/g, "")
    .toLowerCase()}.svg`

  return (
    <div onClick={() => !isFunctionEmpty && handleCategoryCardClick(categoryName)}>
      <div className="category-tile">
        <div className="category-info-section">
          <div className="category-image-section">
            <ImageWithFallback defaultSrc={DefaultServiceLogo} src={serviceLogoURL} />
            {serviceCount > 0 && (
              <Label circular color={"red"}>
                {serviceCount}
              </Label>
            )}
          </div>
          <p className="category-name">{categoryName}</p>
          {description.length > 0 && (
            <Popup
              content={description}
              trigger={
                <Image src={InfoIcon} alt="Info icon" onClick={(e) => e.stopPropagation()} />
              }
              inverted
              position="bottom center"
              on="click"
            />
          )}
        </div>
        <Image className="left-arrow-icon" src={LeftArrowIcon} />
      </div>
    </div>
  )
}

export default ServiceCategoryCard
